import { useMemo } from 'react';

const BitKeep = ({ ...props }) => {
  const id1 = useMemo(() => {
    return `bitKeep_${Math.random().toString(36).substring(7)}_1`;
  }, []);
  const id2 = useMemo(() => {
    return `bitKeep_${Math.random().toString(36).substring(7)}_2`;
  }, []);
  const id3 = useMemo(() => {
    return `bitKeep_${Math.random().toString(36).substring(7)}_3`;
  }, []);
  const id4 = useMemo(() => {
    return `bitKeep_${Math.random().toString(36).substring(7)}_4`;
  }, []);
  const id5 = useMemo(() => {
    return `bitKeep_${Math.random().toString(36).substring(7)}_5`;
  }, []);
  const id6 = useMemo(() => {
    return `bitKeep_${Math.random().toString(36).substring(7)}_6`;
  }, []);

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' {...props}>
      <g clipPath={`url(#${id5})`}>
        <mask id={id6} style={{ maskType: 'luminance' }} maskUnits='userSpaceOnUse' x='0' y='0' width='24' height='24'>
          <path
            d='M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z'
            fill='white'
          />
        </mask>
        <g mask={`url(#${id6})`}>
          <path
            d='M23.9998 12C23.9998 5.37258 18.6272 0 11.9998 0C5.37234 0 -0.000244141 5.37258 -0.000244141 12C-0.000244141 18.6274 5.37234 24 11.9998 24C18.6272 24 23.9998 18.6274 23.9998 12Z'
            fill='#54FFF5'
          />
          <g filter={`url(#${id1})`}>
            <path
              d='M1.26413 18.6186C-2.74913 29.9096 18.7186 26.7206 29.9541 23.7147C41.4533 19.8986 33.5053 3.07684 25.2579 2.70455C17.0106 2.33226 26.2805 10.4828 19.2749 12.8108C12.2692 15.1387 6.28071 4.50479 1.26413 18.6186Z'
              fill='white'
            />
          </g>
          <g filter={`url(#${id2})`}>
            <path
              d='M8.01731 -4.29657C5.9121 -10.0485 -1.58557 -2.25027 -5.07125 2.36782C-8.39615 7.39127 0.282708 11.7323 3.68691 9.3778C7.09111 7.02327 0.72944 6.5652 2.75409 3.50353C4.77875 0.441861 10.6488 2.89331 8.01731 -4.29657Z'
              fill='#00FFF0'
              fillOpacity='0.67'
            />
          </g>
          <g filter={`url(#${id3})`}>
            <path
              d='M9.045 21.1328C6.17347 11.4709 -6.19516 16.5591 -12.0205 20.3109C-17.6241 24.7533 -4.31916 37.532 1.2068 36.8783C6.73273 36.2246 -3.2261 30.6617 0.186289 27.9528C3.59867 25.2439 12.6343 33.2102 9.045 21.1328Z'
              fill='#9D81FF'
            />
          </g>
          <g filter={`url(#${id4})`}>
            <path
              d='M26.4494 -10.0657C20.2551 -17.4417 11.3877 -11.3422 7.72841 -7.37045C4.52633 -2.87421 21.0264 5.36415 25.6058 3.95229C30.1851 2.54044 19.3611 -0.380992 21.3097 -3.12201C23.2583 -5.86303 34.1923 -0.845547 26.4494 -10.0657Z'
              fill='#4D94FF'
            />
          </g>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M8.7373 14.3283H12.814L8.17663 9.66107L12.8736 4.99371L14.1529 3.75H9.92143L4.53233 9.1666C4.26036 9.4396 4.26176 9.8814 4.53512 10.153L8.7373 14.3283ZM11.188 9.672L15.825 14.3389L11.128 19.0063L9.84877 20.25H14.0802L19.4693 14.8337C19.7413 14.5607 19.7399 14.1189 19.4666 13.8473L15.2644 9.672H11.188Z'
            fill='black'
          />
        </g>
      </g>
      <defs>
        <filter
          id={id1}
          x='-8.45978'
          y='-6.53857'
          width='53.3961'
          height='42.3217'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='4.61539' result='effect1_foregroundBlur_795_35' />
        </filter>
        <filter
          id={id2}
          x='-15.0473'
          y='-15.5621'
          width='32.9622'
          height='34.8289'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='4.61539' result='effect1_foregroundBlur_795_35' />
        </filter>
        <filter
          id={id3}
          x='-22.601'
          y='6.34082'
          width='41.7048'
          height='39.7924'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='4.61539' result='effect1_foregroundBlur_795_35' />
        </filter>
        <filter
          id={id4}
          x='-1.91156'
          y='-22.7599'
          width='40.3304'
          height='36.1036'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feBlend mode='normal' in='SourceGraphic' in2='BackgroundImageFix' result='shape' />
          <feGaussianBlur stdDeviation='4.61539' result='effect1_foregroundBlur_795_35' />
        </filter>
        <clipPath id={id5}>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BitKeep;
